<template>
  <div
    class="tw-relative tw-bg-violet-500 dark:tw-bg-green-400 tw-transition-all tw-box-border tw-border-violet-500 dark:tw-border-green-400 tw-group tw-rounded-3xl"
    :class="[
      props.activeCard ? 'tw-rounded-l-2xl' : 'hover:tw-rounded-l-2xl',
      props.clickable ? 'tw-cursor-pointer' : '',
    ]"
  >
    <div
      class="tw-absolute tw-bg-white dark:tw-bg-slate-800 tw-border tw-border-slate-100 dark:tw-border-slate-700 tw-top-0 tw-right-0 tw-transition-all tw-h-full tw-z-0 tw-shadow tw-rounded-2xl"
      :class="[
        props.activeCard
          ? 'tw-w-[calc(100%-4px)] tw-rounded-l-xl'
          : 'tw-w-full group-hover:tw-w-[calc(100%-4px)] group-hover:tw-rounded-l-xl',
      ]"
    ></div>
    <div class="tw-w-full tw-h-full tw-py-3.5 tw-px-4 tw-relative tw-z-10">
      <div
        class="tw-flex tw-gap-1.5 tw-text-sm tw-font-medium tw-text-slate-700 dark:tw-text-slate-300 tw-items-center"
      >
        <i class="tw-text-sm pi" :class="[props.icon]"></i>
        <span>{{ props.title }}</span>
      </div>
      <div class="tw-mt-3.5 tw-w-full tw-relative">
        <Skeleton
          v-if="props.loading"
          class="tw-absolute tw-top-0 tw-left-0 tw-w-full tw-h-full tw-rounded-xl"
        ></Skeleton>
        <div :class="[props.loading ? 'tw-opacity-0' : '']">
          <div
            class="tw-text-slate-700 dark:tw-text-slate-50 tw-text-[40px] tw-leading-none"
          >
            {{ props.value || "0" }}
          </div>
          <div
            class="tw-font-medium tw-mt-0.5"
            :class="{
              'tw-text-green-500': props.secondValue?.startsWith('+'),
              'tw-text-red-500': props.secondValue?.startsWith('-'),
              'tw-text-slate-500':
                props.secondValue && !/^[+-]/.test(props.secondValue),
            }"
          >
            {{ props.secondValue || "0" }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import Skeleton from "primevue/skeleton";

const props = defineProps([
  "title",
  "icon",
  "value",
  "secondValue",
  "loading",
  "activeCard",
  "clickable",
]);
</script>
